var map = {
	"./locale": 845,
	"./locale.js": 845
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2195;


//////////////////
// WEBPACK FOOTER
// ./~/moment-mini/locale ^\.\/.*$
// module id = 2195
// module chunks = 1